import { Outlet } from 'react-router-dom';
import AppHeader from '@/components/layout/AppHeader';
import AppSidebar from '@/components/layout/AppSidebar';

import { useAuth } from '@/helpers/api';
import { useTheme } from './helpers/theme';

const App = () => {
  useAuth();
  useTheme();

  return (
    <>
      <AppHeader />
      <div className="min-h-[calc(100vh-var(--header-height))]">
        <AppSidebar />
        <main className="pl-[280px] max-w-[1800px] mx-auto">
          <div className="p-4">
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
};

export default App;
